export const NAV_LABELS = {
  COMPLIANCE_SUBSCRIPTION: "Subskrypcja Zgodności",
  FIRE_DETECTION_INSPECTION: "Przegląd Systemów Wykrywania Pożaru",
  FIRE_EQUIPMENT_INSPECTION: "Przegląd Sprzętu Przeciwpożarowego",
  EVACUATION_FIRE_PROTECTION_INSPECTION:
    "Przegląd Zabezpieczeń Ewakuacyjnych i Przeciwpożarowych",
  ELECTRICAL_CHECK: "Przegląd Instalacji Elektrycznej",
  ELECTRICAL_MEASUREMENTS: "Pomiary Elektryczne",
  GAS_CHECK: "Przegląd Instalacji Gazowej",
  ENERGY_STORAGE_INSPECTION: "Przegląd Magazynu Energii",
  SWITCHBOARD_INSPECTION: "Rozdzielnia Elektryczna",

  SOLUTIONS: "Rozwiązania",
  FOR_PROPERTY_MANAGERS: "Przeglądy dla Zarządców Nieruchomości",
  FOR_LANDLORDS: "Przeglądy dla Właścicieli Mieszkań na Wynajem",
  FOR_BUILDING_MANAGERS: "Przeglądy dla Administratorów Budynków",
  FOR_HOMEOWNERS: "Przeglądy dla Właścicieli Domów",
  FOR_REAL_ESTATE: "Przeglądy dla Biur Nieruchomości",

  BLOG: "Poradnik",
  CITIES: "Miasta",
  FAQ: "FAQ",
  ABOUT_US: "O nas",
  BOOK_NOW: "Zarezerwuj Przegląd",
  CONTACT_US: "Kontakt",
  LEGISLATION: "Legislacja",
  PRIVACY_POLICY: "Polityka Prywatności",
};
